<template>
  <div
    class="tm-online-status-badge"
    :class="[
      {
        'tm-online-status-badge--online': isOnline,
      },
      `tm-online-status-badge--size-${size}`,
    ]"
  />
</template>

<script setup lang="ts">
const { size = 'medium' } = defineProps<{
  isOnline?: boolean
  size?: 'small' | 'medium' | 'large' | 'xLarge'
}>()
</script>

<style scoped lang="scss">
@mixin size($size, $borderWidth) {
  &::before {
    width: $size;
    height: $size;
  }
  &::after {
    width: $size - $borderWidth * 2;
    height: $size - $borderWidth * 2;
  }
}

.tm-online-status-badge {
  // Border. Should not affect box size
  &::before {
    content: '';
    display: block;
    background: $white;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  // Dot
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    background: $light;
    position: relative;
  }

  &--online::after {
    background: $green;
  }

  &--size-small {
    @include size(8px, 1px);
  }

  &--size-medium {
    @include size(12px, 2px);
  }

  &--size-large {
    @include size(14px, 2px);
  }

  &--size-xLarge {
    @include size(16px, 2px);
  }
}
</style>
